// Recovered compiled webpack factory 73314. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { GS: () => s, HF: () => h, W4: () => f, my: () => l, pO: () => u, sp: () => c });
  var n = r(61571),
    a = r(60567),
    o = r(43275),
    i = r(16649);
  function s(e, t, r) {
    if (!(t in e)) return;
    let a = e[t];
    if ("function" != typeof a) return;
    let i = r(a);
    "function" == typeof i && u(i, a);
    try {
      e[t] = i;
    } catch {
      n.T && o.Yz.log(`Failed to replace method "${t}" in object`, e);
    }
  }
  function l(e, t, r) {
    try {
      Object.defineProperty(e, t, { value: r, writable: !0, configurable: !0 });
    } catch {
      n.T && o.Yz.log(`Failed to add non-enumerable property "${t}" to object`, e);
    }
  }
  function u(e, t) {
    try {
      let r = t.prototype || {};
      ((e.prototype = t.prototype = r), l(e, "__sentry_original__", t));
    } catch {}
  }
  function c(e) {
    return e.__sentry_original__;
  }
  function f(e) {
    if ((0, i.bJ)(e)) return { message: e.message, name: e.name, stack: e.stack, ...p(e) };
    if (!(0, i.xH)(e)) return e;
    {
      let t = { type: e.type, target: d(e.target), currentTarget: d(e.currentTarget), ...p(e) };
      return (
        "undefined" != typeof CustomEvent && (0, i.tH)(e, CustomEvent) && (t.detail = e.detail),
        t
      );
    }
  }
  function d(e) {
    try {
      return (0, i.vq)(e) ? (0, a.Hd)(e) : Object.prototype.toString.call(e);
    } catch {
      return "<unknown>";
    }
  }
  function p(e) {
    return "object" == typeof e && null !== e ? Object.fromEntries(Object.entries(e)) : {};
  }
  function h(e) {
    let t = Object.keys(f(e));
    return (t.sort(), t[0] ? t.join(", ") : "[object has no keys]");
  }
}
